'use client'

import { Fragment, useEffect } from 'react'
import { Divider, Spacer } from '@vinted/web-ui'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import { ErrorState } from '@marketplace-web/error-display/error-display-feature'
import {
  getInfoBoardPosts,
  transformInfoBoardPostsResponse,
  InfoBoardPostModel,
} from '@marketplace-web/info-board/info-board-data'

import { InfoPost } from './InfoPost'

const InfoBoard = () => {
  const {
    fetch: fetchInfoBoardPosts,
    transformedData: posts,
    error,
    isLoading,
  } = useFetch(getInfoBoardPosts, transformInfoBoardPostsResponse)

  useEffect(() => {
    fetchInfoBoardPosts()
  }, [fetchInfoBoardPosts])

  const renderPost = (post: InfoBoardPostModel, index: number) => {
    return (
      <Fragment key={index}>
        <div className="u-mobiles-only">
          <Spacer size="x3-large" />
        </div>
        <div className="u-desktops-only">
          <Spacer size="x4-large" />
        </div>
        <InfoPost {...post} />
        <div className="u-mobiles-only">
          <Spacer size="x3-large" />
        </div>
        <div className="u-desktops-only">
          <Spacer size="x4-large" />
        </div>
        <Divider />
      </Fragment>
    )
  }

  if (isLoading) return <ContentLoader testId="infoboard-loader" />

  if (error) return <ErrorState />

  return (
    <>
      <div className="u-mobiles-only">
        <Spacer size="large" />
      </div>
      <div className="u-desktops-only">
        <Spacer size="x2-large" />
      </div>
      {posts?.map(renderPost)}
      <Spacer size="x6-large" />
    </>
  )
}

export default InfoBoard
